import { summaryTableStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

Object.assign(summaryTableStyles, {
    lineItem: {
        width: 12,
        css: css`
            border: 1px solid #e1e7ed;
            border-radius: 10px;
            margin: 10px !important;
            @media print {
                max-width: 100%;
                border: 1px solid #e1e7ed;
                border-radius: 10px;
                margin: 10px !important;
            }
        `,
    },
    title: {
        weight: "bold",
        as: "h3",
        css: css`
            @media print {
                font-size: 15px;
            }
            width: 100%;
            padding: 15px 0 0 0;
            border-bottom: 0;
        `,
    },
    titleItem: {
        width: 12,
        css: css`
            padding-bottom: 0px;
        `,
    },
    linesInnerContainer: {
        css: css`
            ${GridOffset} {
                display: flex;
            }
        `,
    },
    container: {
        css: css`
            > ${GridOffset} {
                width: calc(100% + 30px) !important;
            }
        `,
    },
});
